import useTranslation from 'hooks/useTranslation'
import Skeleton from 'react-loading-skeleton'
import { CARD_TYPE } from 'utils/validation'
import { toPhoneString } from 'utils/string'

const Receipt = ({ data, independent = false, editAction, warning }) => {
  const { id, name, pesel, street, building_nr, apartment_nr, zip_code, city, phone = '', prefix, email, identity_card_type, identity_card } = data || {}
  const { t } = useTranslation('form')

  const element = <div>
    <div className='list__header element__title'>{t('contractData')}</div>
    <div className='list__element --big'>
      {id ?
        <div className='element__title'>
          <div>{name}</div>
          {pesel
            ? <div>PESEL: {pesel}</div>
            : identity_card_type
              ? <div>{t(identity_card_type === CARD_TYPE.idCard ? 'idNumber' : identity_card_type === CARD_TYPE.passport ? 'passportNumber' : 'drivingLicenseNumber')}: {identity_card}</div>
              : null}
        </div>
        : <Skeleton />}

      {id ?
        <div className='group'>
          <div className='element__desc'>
            <div>{street} {building_nr}{apartment_nr ? `/${apartment_nr}` : ''}</div>
            <div>{zip_code} {city}</div>
            <div>tel. {toPhoneString(phone, prefix)}</div>
            <div>email: {email}</div>
          </div>
          {editAction && <p
            className='element__edit'
            onClick={editAction}>
            {t('edit')}
          </p>}
        </div>
        : <Skeleton
          count={4}
          containerClassName='skeleton__desc' />}
    </div>
    {warning && <div
      className='billing__missing'
      onClick={editAction}>
      {warning}
    </div>}
  </div>

  return (
    independent
      ? element
      : <div className='billing__receipt summary'>
        <div className='list'>
          {element}
        </div>
      </div>
  )
}

export default Receipt